import { render } from "./registerNews.vue?vue&type=template&id=4f922452&scoped=true"
import script from "./registerNews.vue?vue&type=script&lang=js"
export * from "./registerNews.vue?vue&type=script&lang=js"

import "./registerNews.vue?vue&type=style&index=0&id=4f922452&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f922452"

export default script